import {
  Button,
  Card,
  Divider,
  Flex,
  Group,
  Stack,
  TagsInput,
  Title,
  Tooltip,
} from "@mantine/core";
import React from "react";
import AddOrderItem from "./AddOrderItem";
import { IconPlus } from "@tabler/icons-react";
import { useForm } from "@mantine/form";
import { CreateOrderDto } from "../../../../types/accountManagementTypes";

export interface OrderLicenseStepProps {
  onCreate: (payload: CreateOrderDto) => void;
}

const OrderLicenseStep: React.FC<OrderLicenseStepProps> = (props) => {
  const { onCreate } = props;
  const licenseTypesData = [
    { value: "basic-vfa", label: "Basic VFA" },
    { value: "upgraded-vfa", label: "Upgraded VFA" },
    { value: "full-vfa", label: "Full VFA" },
    { value: "demo", label: "Demo" },
    { value: "unset", label: "Unset" },
    { value: "subscription", label: "Subscription" },
    { value: "nonprofit", label: "Nonprofit" },
  ];

  const form = useForm({
    initialValues: {
      orderItems: [{ isHardware: false, licenseType: "basic-vfa", quantity: 1 }],
      emailsToInform: [],
    },

    validate: {
      emailsToInform: (value) => {
        if (value.length === 0) {
          return "Email list cannot be empty";
        }
        for (const email of value) {
          if (!/^\S+@\S+$/.test(email)) {
            return "Invalid email";
          }
        }
        return null;
      },
    },
  });

  function createOrderPayload(values: any): CreateOrderDto {
    return {
      orderItems: values.orderItems,
      emailsToInform: values.emailsToInform,
    };
  }

  const addLicenseCard = () => (
    <Card withBorder p="md" radius="md">
      <Card.Section p="md">
        <Title order={4}>Add Licenses</Title>
      </Card.Section>

      {form.values.orderItems.map((item, index) => (
        <React.Fragment key={index}>
          {index !== 0 && <Divider my="md" />}
          <AddOrderItem
            licenseData={licenseTypesData}
            form={form}
            index={index}
            removeItem={() => form.removeListItem("orderItems", index)}
          />
        </React.Fragment>
      ))}
      {form.values.orderItems.length > 0 && <Divider my="md" />}
      <Button
        leftSection={<IconPlus />}
        variant="transparent"
        onClick={() =>
          form.insertListItem("orderItems", {
            isHardware: false,
            licenseType: "basic-vfa",
            quantity: 1,
          })
        }
      >
        Add Another License
      </Button>
    </Card>
  );

  const orderDetailsCard = () => (
    <Card withBorder p="md" radius="md">
      <Card.Section p="md">
        <Title order={4}>Order Details</Title>
      </Card.Section>
      <Tooltip
        label="The emails entered here will be notified when the order is created."
        withArrow
        position="bottom"
        multiline
        w={220}
      >
        <TagsInput
          label={"Emails to Inform"}
          placeholder="Enter email"
          clearable
          data={form.values.emailsToInform}
          {...form.getInputProps("emailsToInform")}
        />
      </Tooltip>
    </Card>
  );

  return (
    <form onSubmit={form.onSubmit((values) => onCreate(createOrderPayload(values)))}>
      <Stack>
        {addLicenseCard()}
        {orderDetailsCard()}
        <Flex justify="flex-end" align="center">
          <Group gap={"md"}>
            <Button variant="outline">Cancel</Button>
            <Button type="submit" disabled={!form.values.orderItems.length}>
              Create
            </Button>
          </Group>
        </Flex>
      </Stack>
    </form>
  );
};

export default OrderLicenseStep;
